<template src="./template.html"></template>

<script setup>
import { showSnackbar } from "@/helper"
import { i18n } from '@/translations/i18n'
import { watch, computed, onMounted } from "vue"
import { useCart } from "@/app/Checkout/composables/useCart"
import { useCheckout } from "@/app/Checkout/composables/useCheckout"
import { usePayment, paymentManager } from "@/composables/usePayment"

const { cart } = useCart()
const { activePaymentMethod } = useCheckout()
const { adyenConfig, proceedToPayment } = usePayment()
const allowedCardNetworks = computed(() => adyenConfig.value?.allowedCardNetworks?.[activePaymentMethod.value] || [])

let session = null
const paymentRequest = {
  currencyCode: cart?.value?.currency,
  countryCode: adyenConfig.value?.countryCode,
  total: {
    label: "Niche Beauty",
    amount: cart.value?.total_price_numeric,
  },
  supportedNetworks: allowedCardNetworks.value,
  merchantCapabilities: ['supports3DS', 'supportsCredit', 'supportsDebit'],
}

watch(allowedCardNetworks, (brands) => {
  paymentRequest.supportedNetworks = brands
})

const onValidateMerchant = async function(event) {
  const validationUrl = event.validationURL
  const payload = JSON.stringify({ validationUrl: validationUrl })
  const locale = i18n.locale ? i18n.locale.toLowerCase() : `${window.config.lang || 'de'}-${window.config.country || 'de'}`
  const url = `/${locale}/checkout/validate_apple_pay_merchant`

  try {
    const res = await fetch(url, {
      method: "POST",
      body: payload,
      headers: {
        "Content-Type": "application/json",
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      }
    });

    const data = await res.json()

    session.completeMerchantValidation(data)
  } catch (error) {
    showSnackbar('error', 'iconfont-info', error)
  }
}

const onPaymentAuthorized = async function(event) {
  try {
    const paymentData = event.payment.token.paymentData;

    const res = await proceedToPayment({ applepay_token: paymentData }, false)
    const data = res.json ? await res.json() : res

    if (data.success) {
      session.completePayment(ApplePaySession.STATUS_SUCCESS);
      const redirectUrl = data.url
      const absoluteUrl = redirectUrl.startsWith('http')
          ? redirectUrl
          : window.location.origin + redirectUrl
      window.location.assign(absoluteUrl)
    } else {
      session.completePayment(ApplePaySession.STATUS_FAILURE);
    }
  } catch(error) {
    session.completePayment(ApplePaySession.STATUS_FAILURE);
  }
}

const preInitApplePay = () => {
  if (window.ApplePaySession && ApplePaySession.canMakePayments()) {
    try {
      session = new ApplePaySession(3, paymentRequest)
    } catch (error) {
      console.error(error);
    }
  }
}

const initApplePay = () => {
  if (window.ApplePaySession && ApplePaySession.canMakePayments()) {
    try {
      session.onvalidatemerchant = onValidateMerchant
      session.onpaymentauthorized = onPaymentAuthorized

      if (session) {
        session.begin();
      }
    } catch (error) {
      showSnackbar('error', 'iconfont-info', error)
    }
  } else {
    showSnackbar('error', 'iconfont-info', 'This device does not support Apple Pay')
  }
}

onMounted(() => {
  paymentManager.register({
    preInit: preInitApplePay,
    init: initApplePay,
  })
})
</script>
